/**
 * Single source of truth for the annotation-stats UI gate.
 *
 * Two surfaces consult this predicate so the same env var produces the
 * same default everywhere:
 *
 *   - /labeling          (LabelingPage.tsx — AnnotationSpeedDashboard)
 *   - /labeling/urinary-stone (SegStudyHome.tsx — Stats tab)
 *
 * Policy: env-var only — production hides Stats from everyone, including
 * admins, until `VITE_STATS_ALLOWED_USERS` is set. Set to "*" to open to all
 * (demo deployments), or a comma-separated list of userIds for a narrow
 * allowlist. There is intentionally no userType / role fallback: a previous
 * iteration had three surfaces with three different defaults, and the
 * resulting "shows on one URL, hidden on another" behavior was the bug this
 * file exists to prevent.
 */

const RAW = import.meta.env.VITE_STATS_ALLOWED_USERS;

if (RAW === undefined) {
  console.warn(
    'VITE_STATS_ALLOWED_USERS env var is not set — annotation speed stats will be hidden for all users. Set to "*" to allow everyone.',
  );
}

export const STATS_ALLOWED_USERS: readonly string[] = (RAW ?? "")
  .split(",")
  .map((s: string) => s.trim())
  .filter(Boolean);

/** Whether the given user may see annotation-stats UI. */
export function canViewStats(userId: string | null | undefined): boolean {
  if (STATS_ALLOWED_USERS.includes("*")) return true;
  if (userId && STATS_ALLOWED_USERS.includes(userId)) return true;
  return false;
}
